import axios from 'axios';

// const API_BASE_URL =  'https://freakers-backend.onrender.com/api';
// const API_BASE_URL =  'https://freakers-backend-uat.onrender.com/api';
// const API_BASE_URL =  'https://freakers-backend-xfux.onrender.com/api';

const API_BASE_URL = 'https://fbackend-jnop.onrender.com/api';
// const API_BASE_URL =  'http://localhost:5001/api';
// 10.158.76.101
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('userToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // If FormData, remove Content-Type to let browser set it with boundary
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle token expiration (don't redirect on 401 from login/signup/forgot-password so toast can show)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const url = error.config?.url || '';
      const isAuthRequest = /\/user\/auth\/(login|signup|forgot-password)/.test(url);
      if (!isAuthRequest) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('user');
        sessionStorage.setItem('loginRedirectMessage', 'Please log in to continue.');
        window.location.href = `${process.env.PUBLIC_URL || ''}/login`;
      }
    }
    return Promise.reject(error);
  }
);

// Helper methods - store original methods before overriding
const originalGet = api.get.bind(api);
const originalPost = api.post.bind(api);
const originalPut = api.put.bind(api);
const originalDelete = api.delete.bind(api);

// Override with helper methods that return data directly
api.get = (url, config) => originalGet(url, config).then((res) => res.data);
api.post = (url, data, config) => {
  // Handle FormData for file uploads - don't set Content-Type header, let browser set it with boundary
  if (data instanceof FormData) {
    const customConfig = {
      ...config,
      headers: {
        ...config?.headers,
        // Remove Content-Type to let browser set it with boundary
      },
    };
    // Remove Content-Type if it was set
    if (customConfig.headers && customConfig.headers['Content-Type']) {
      delete customConfig.headers['Content-Type'];
    }
    return originalPost(url, data, customConfig).then((res) => res.data);
  }
  return originalPost(url, data, config).then((res) => res.data);
};
api.put = (url, data, config) => originalPut(url, data, config).then((res) => res.data);
api.delete = (url, config) => originalDelete(url, config).then((res) => res.data);

export default api;

